// extracted by mini-css-extract-plugin
export var productImage = "_s1-1";
export var viewLink = "_s1-2";
export var wishlistItem = "_s1-0";